import Auth from "./Auth";
import { fetchdata } from "./util";
import { logout } from "./util";
export default function MethodURL(props) {
  return (
    <div id="method-url">
      <div className="select request-items">
        <select id="method">
          <option>GET</option>
          <option>POST</option>
          <option>PUT</option>
          <option>PATCH</option>
          <option>DELETE</option>
        </select>
      </div>
      <input
        id="url"
        className="input is-primary request-items"
        type="text"
        placeholder="e.g. gateway.mindsphere.io/api/v1/iot"
      />
      <button
        id="submit"
        className="button is-primary request-items"
        onClick={fetchdata}
      >
        Send
      </button>
      <a
        id="logout"
        className="button is-primary request-items"
        href="./logout"
      >
        Logout
      </a>
      <div class="link-group">
        <a
          id="redirectcors-localhost"
          className="button is-primary request-items"
          href="https://localhost:3000/qvapp/"
        >
          RedirectCors(Localhost)
        </a>
        <a
          id="redirectcors-app"
          className="button is-primary request-items"
          href="https://corsapp.mdsp-nfr.ocimaws.net"
        >
          RedirectCors
        </a>
        <a
          id="redirectcors-appmtest)"
          className="button is-primary request-items"
          href="https://corsappmtest.mdsp-nfr.ocimaws.net"
        >
          RedirectCors(mtest)
        </a>
      </div>
    </div>
  );
}
